export default __webpack_public_path__ + "static/media/081296saarc.1d285c33.jpg";